export const whatsappNumber = "905323953104";
export const whatsappMessage = encodeURIComponent(
  "Merhaba, Karasu Plaj Cadde Tekel'den bilgi almak istiyorum."
);
export const displayPhone = "0532 395 31 04";
export const shopAddress = "Karasu, Plaj Caddesi";
export const shopName = "Plaj Cadde Tekel";